import SharedVendorLogo from '@/shared/components/VendorSearchAutocomplete/VendorLogo';
import { getInitials } from '../utils/formatters';

interface VendorLogoProps {
  vendorName: string;
  logoUrl: string | null;
  size?: number;
}

export function VendorLogo({ vendorName, logoUrl, size = 20 }: VendorLogoProps) {
  const initials = getInitials(vendorName);

  if (!logoUrl) {
    return (
      <div
        className="flex items-center justify-center rounded-full border border-[#E2E8F0] bg-[#F8FAFC] flex-shrink-0"
        style={{ width: size, height: size }}
      >
        <span
          className="font-['Inter'] font-medium text-[#62748E]"
          style={{ fontSize: size * 0.4 }}
        >
          {initials}
        </span>
      </div>
    );
  }

  return (
    <SharedVendorLogo
      src={logoUrl}
      alt={vendorName}
      needsAuthToken={true}
      size={size}
      radius="full"
    />
  );
}
